import store from "@/store";
import request from "@/utils/request";


export async function getCsFileMappingList(params) {
    console.log("@@ get list : getCsFileMappingList");
    let result = request.get("/api/cs/csFileMapping/",{params});
    return result;
}

export async function getCsFileMappingItem(params) {
    console.log("@@ get item : getCsFileMappingItem");
    let result = request.get(`/api/cs/csFileMapping/${params.mappingSeq}`,{params} );
    return result;
}

export async function saveCsFileMapping(params) {
    console.log("@@ post save : saveCsFileMapping");
    let result = request.post(`/api/cs/csFileMapping/`,params);
    return result;
}

export async function saveCsFileMappingList(params) {
    console.log("@@ post save : saveCsFileMappingList");
    let result = request.post(`/api/cs/csFileMapping/list`,params);
    return result;
}

export async function saveCsFileMappingUsingList(params) {
    console.log("@@ post save : saveCsFileMappingUsingList");
    let result = request.post(`/api/cs/csFileMapping/using`,params);
    return result;
}


export async function getCsFileMappingLocationList(params) {
    console.log("@@ get list : getCsFileMappingLocationList");
    let result = request.get("/api/cs/csFileMapping/list/location",{params});
    return result;
}

export async function deleteCsFileMapping(params) {
    console.log("@@ delete : deleteCsFileMapping");
    let result = request.delete(`/api/cs/csFileMapping/`,{params});
    return result;
}
